import { render, staticRenderFns } from "./CardAssignment.vue?vue&type=template&id=4323a562"
import script from "./CardAssignment.vue?vue&type=script&lang=js"
export * from "./CardAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports